export const categories = [
  { name: "热血", icon: "ri-fire-line", desc: "燃到最后一秒" },
  { name: "科幻", icon: "ri-planet-line", desc: "想象无边界" },
  { name: "恋爱", icon: "ri-heart-line", desc: "怦然心动" },
  { name: "奇幻", icon: "ri-magic-line", desc: "另一个世界" },
  { name: "悬疑", icon: "ri-search-eye-line", desc: "烧脑推理" },
  { name: "日常", icon: "ri-cup-line", desc: "温柔治愈" },
  { name: "冒险", icon: "ri-compass-3-line", desc: "踏上旅途" },
  { name: "战斗", icon: "ri-sword-line", desc: "刀光剑影" },
  { name: "机甲", icon: "ri-robot-2-line", desc: "钢铁浪漫" },
  { name: "治愈", icon: "ri-leaf-line", desc: "抚平疲惫" },
];

export const heroSlides = [
  {
    id: "1",
    animeId: "1",
    title: "苍穹之翼",
    subtitle: "本季最热血天空冒险 · 正在连载",
    desc: "少年驾驶苍穹战机，穿越大片云海，追寻失踪姐姐的身影。每一次飞行，都在改写世界的命运。",
    tag: "热血 / 冒险",
    image:
      "https://readdy.ai/api/search-image?query=epic%20anime%20key%20visual%20of%20a%20young%20pilot%20soaring%20through%20golden%20sunset%20clouds%20with%20a%20futuristic%20airship%2C%20warm%20orange%20cinematic%20lighting%2C%20dramatic%20sky%2C%20high%20detail%20background%20art&width=1600&height=900&seq=hero-slide-01&orientation=landscape",
  },
  {
    id: "2",
    animeId: "6",
    title: "时空回廊",
    subtitle: "烧脑悬疑新作 · 每周更新",
    desc: "一桩七天后的命案，一条可以穿越时间的回廊。侦探诺兰的每一次回溯，都在改写下一次悲剧的起点。",
    tag: "悬疑 / 推理",
    image:
      "https://readdy.ai/api/search-image?query=moody%20anime%20key%20visual%20of%20a%20detective%20in%20an%20endless%20mirrored%20corridor%20with%20glowing%20clocks%2C%20deep%20amber%20and%20shadow%20tones%2C%20mysterious%20cinematic%20background%20art&width=1600&height=900&seq=hero-slide-02&orientation=landscape",
  },
  {
    id: "3",
    animeId: "17",
    title: "精灵契约",
    subtitle: "奇幻冒险 · 全新连载",
    desc: "少女艾拉召唤出一只胆小的小精灵，却不知这个不起眼的伙伴，藏着传说中沉睡已久的古老力量。",
    tag: "奇幻 / 冒险",
    image:
      "https://readdy.ai/api/search-image?query=fantasy%20anime%20key%20visual%20of%20a%20young%20summoner%20surrounded%20by%20glowing%20spirits%20in%20an%20enchanted%20forest%2C%20emerald%20and%20warm%20orange%20tones%2C%20magical%20cinematic%20background%20art&width=1600&height=900&seq=hero-slide-03&orientation=landscape",
  },
  {
    id: "4",
    animeId: "18",
    title: "深海之歌",
    subtitle: "治愈系完结佳作 · 一口气看完",
    desc: "海底深处，歌声能治愈所有受伤的心。少女琉音第一次浮上海面，只为寻找失踪母亲的踪迹。",
    tag: "治愈 / 音乐",
    image:
      "https://readdy.ai/api/search-image?query=ethereal%20anime%20key%20visual%20of%20a%20girl%20singing%20among%20glowing%20jellyfish%20in%20a%20deep%20ocean%20realm%2C%20teal%20and%20gold%20bioluminescent%20glow%2C%20dreamy%20cinematic%20background%20art&width=1600&height=900&seq=hero-slide-04&orientation=landscape",
  },
];

export const topics = [
  {
    id: "season-hot",
    title: "本季热门动画专题",
    desc: "精选本季讨论度最高的十部作品，一次看过瘾。",
    count: 10,
    href: "/anime?sort=popular",
    image:
      "https://readdy.ai/api/search-image?query=anime%20feature%20topic%20collage%20of%20dynamic%20heroes%20and%20glowing%20effects%2C%20warm%20orange%20and%20cream%20palette%2C%20editorial%20poster%20collection&width=800&height=600&seq=topic-01&orientation=landscape",
  },
  {
    id: "healing",
    title: "治愈日常精选合辑",
    desc: "忙碌之后的温柔陪伴，治愈系作品合集。",
    count: 6,
    href: "/anime?type=治愈",
    image:
      "https://readdy.ai/api/search-image?query=anime%20topic%20collage%20of%20cozy%20cafe%20and%20sunlit%20everyday%20scenes%2C%20cream%20and%20warm%20orange%20palette%2C%20gentle%20editorial%20poster%20collection&width=800&height=600&seq=topic-02&orientation=landscape",
  },
  {
    id: "new-2024",
    title: "2024 新番追更指南",
    desc: "年度新番全收录，帮你不错过任何一部好作品。",
    count: 12,
    href: "/anime?year=2024",
    image:
      "https://readdy.ai/api/search-image?query=anime%20topic%20collage%20of%20futuristic%20mecha%20and%20star%20voyage%20scenes%2C%20deep%20orange%20and%20steel%20tones%2C%20editorial%20poster%20collection&width=800&height=600&seq=topic-03&orientation=landscape",
  },
];

export const stats = [
  { label: "收录动漫作品", value: "25,000+" },
  { label: "每日更新资讯", value: "120+" },
  { label: "活跃动漫爱好者", value: "860,000+" },
  { label: "覆盖类型分类", value: "30+" },
];

export const aboutValues = [
  {
    icon: "ri-book-open-line",
    title: "丰富的内容库",
    desc: "从热血冒险到治愈日常，我们持续收录并整理各类型动漫作品，让每一位爱好者都能找到心头所好。",
  },
  {
    icon: "ri-rocket-2-line",
    title: "及时的资讯更新",
    desc: "关注行业动态、新番情报与作品评测，用专业而轻快的表达，把最新鲜的动漫资讯送到你面前。",
  },
  {
    icon: "ri-hearts-line",
    title: "为爱好者而生",
    desc: "我们本身就是动漫爱好者。51动漫的每一个功能，都源于想让自己和同好们看得更爽、更省心。",
  },
];

export const team = [
  { name: "星野", role: "内容主理人", avatar: "https://readdy.ai/api/search-image?query=friendly%20flat%20illustration%20avatar%20of%20a%20cheerful%20young%20editor%20with%20orange%20background%2C%20minimal%20style%20portrait&width=300&height=300&seq=team-01&orientation=squarish" },
  { name: "林澈", role: "评测负责人", avatar: "https://readdy.ai/api/search-image?query=friendly%20flat%20illustration%20avatar%20of%20a%20calm%20young%20reviewer%20with%20warm%20cream%20background%2C%20minimal%20style%20portrait&width=300&height=300&seq=team-02&orientation=squarish" },
  { name: "苏晚", role: "剧情解析", avatar: "https://readdy.ai/api/search-image?query=friendly%20flat%20illustration%20avatar%20of%20an%20insightful%20young%20analyst%20with%20coral%20background%2C%20minimal%20style%20portrait&width=300&height=300&seq=team-03&orientation=squarish" },
  { name: "阿禾", role: "社区运营", avatar: "https://readdy.ai/api/search-image?query=friendly%20flat%20illustration%20avatar%20of%20a%20lively%20community%20manager%20with%20olive%20green%20background%2C%20minimal%20style%20portrait&width=300&height=300&seq=team-04&orientation=squarish" },
];

export const contactInfo = {
  email: "hello@51anime.com",
  phone: "400-051-5151",
  address: "浙江省杭州市滨江区动漫大厦 18 层",
  hours: "周一至周五 09:00 - 18:00",
};